module.exports = __webpack_public_path__ + "img/xnr4.edccb7e2.png";